import React from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';

import logger from 'utils/logger';
import { sortByNewest } from 'utils/javascript';

import Create from './Create';
import Comment from './Comment';
import { Comments, Title } from './Styles';

const log = logger.createLogger('ProjectBoardIssueDetailsComments');

const propTypes = {
  issue: PropTypes.object.isRequired,
  fetchIssue: PropTypes.func.isRequired,
  isClient: PropTypes.bool.isRequired,
  updateLocalProjectIssues: PropTypes.func,
  handlePreviewButtonClick: PropTypes.func,
  quoteAttachment: PropTypes.object,
  refreshQuote: PropTypes.number,
  commentEditorRef: PropTypes.shape({
    // Quill object
    current: PropTypes.object,
  }),
  isCommentFormOpen: PropTypes.bool,
  setIsCommentFormOpen: PropTypes.func,
  handleClearQuoteAttachment: PropTypes.func.isRequired,
};

const ProjectBoardIssueDetailsComments = ({
  issue,
  fetchIssue,
  isClient,
  updateLocalProjectIssues,
  handlePreviewButtonClick,
  quoteAttachment,
  refreshQuote,
  commentEditorRef,
  isCommentFormOpen,
  setIsCommentFormOpen,
  handleClearQuoteAttachment,
}) => {
  const attachments = [
    ...issue.attachmentsOwnedBySrcOrg,
    ...issue.attachmentsOwnedByDstOrg,
  ];
  return (
    <Comments>
      <Title>{intl.get('issue_details_text_comments')}</Title>
      <Create
        issueId={issue.id}
        fetchIssue={fetchIssue}
        isClient={isClient}
        updateLocalProjectIssues={updateLocalProjectIssues}
        quoteAttachment={quoteAttachment}
        refreshQuote={refreshQuote}
        commentEditorRef={commentEditorRef}
        isCommentFormOpen={isCommentFormOpen}
        setIsCommentFormOpen={setIsCommentFormOpen}
        handleClearQuoteAttachment={handleClearQuoteAttachment}
      />

      {sortByNewest(issue.comments, 'createdAt').map((comment) => (
        <Comment
          key={comment.id}
          comment={comment}
          issueAttachments={attachments}
          fetchIssue={fetchIssue}
          handlePreviewButtonClick={handlePreviewButtonClick}
        />
      ))}
    </Comments>
  );
};

ProjectBoardIssueDetailsComments.propTypes = propTypes;

export default ProjectBoardIssueDetailsComments;
